import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch } from 'react-redux';

import pkdApi from 'store/api/pkd';
import auth0Api from 'store/api/auth0';
import { resetAll } from 'store/reset';

export const useLogout = () => {
  const { logout } = useAuth0();
  const dispatch = useDispatch();

  // Handlers
  const handleLogout = async () => {
    localStorage.clear();
    dispatch(pkdApi.util.resetApiState());
    dispatch(auth0Api.util.resetApiState());
    dispatch(resetAll());
    logout({ logoutParams: { returnTo: 'https://pkdcure.org/registry' } });
  };

  return {
    handleLogout,
  };
};
